import Vue from "vue";
import Router from "vue-router";
import Home from "../components/home/home.vue";
import Login from "../components/auth/AppLogin";
import Corporate from "@/components/corporate/Corporate";
import Account from "@/components/account/AccountList";
import AccountDetail from "@/components/account/AccountDetail";
import Stores from "@/components/store/Stores";
import StoreDetail from "@/components/store/StoreDetail";
import UserList from "@/components/user/UserList";
import RoleList from "@/components/user/role/RoleList";
import PosServer from "@/components/posServers/PosServers";
import Apps from "@/components/digitoryApps/Apps";
import Inventory from "@/components/inventory/Tenants";
import EventAccount from "@/components/event/account/accountList";
import OAuthExchange from "../components/auth/OAuthExchange.vue";
import MigrationDashboard from "@/components/sso/MigrationDashboard";


import store from "@/store";

Vue.use(Router);
const router = new Router({
	routes: [
		{
			path: "/login",
			name: "login",
			component: Login,
			meta: {
				auth: false
			},
			beforeEnter: (to, from, next) => {
				const token = localStorage.getItem("admin_user_token");
				if (token) {
					next("/");
					return;
				}
				next();
			}
		},
		{
			path: "/oAuth/exchange",
			name: "oAuthExchange",
			component: OAuthExchange,
			meta: {
				auth: false
			}
		},


		{
			path: "/home",
			name: "home",
			component: Home,
			meta: {
				auth: true
			},
			redirect: "stores",
			children: [
				{
					name: "corporate",
					path: "/corporate",
					component: Corporate
				},
				{
					name: "accounts",
					path: "/accounts",
					component: Account
				},
				{
					name: "stores",
					path: "/stores",
					component: Stores
				},
				{
					name: "accountInfo",
					path: "/accounts/:accountId",
					component: AccountDetail
				},
				{
					name: "storeInfo",
					path: "/accounts/:accountId/stores/:storeId",
					component: StoreDetail
				},
				{
					name: "loginMigration",
					path: "/sso/migration",
					component: MigrationDashboard
				},
				{
					name: "users",
					path: "/users",
					component: UserList,
					meta: {
						auth: true,
						privilege: "USER_UPDATE"
					}
				},
				{
					name: "roles",
					path: "/roles",
					component: RoleList,
					meta: {
						auth: true,
						privilege: "USER_UPDATE"
					}
				},
				{
					name: "posServers",
					path: "/posServers",
					component: PosServer
				},
				{
					name: "apps",
					path: "/apps",
					component: Apps
				},
				{
					name: "inventory",
					path: "/inventory",
					component: Inventory
				},
				{
					name: "eventAccounts",
					path: "/eventAccounts",
					component: EventAccount
				}
			]
		},
		{
			path: "*",
			redirect: "/home"
		}
	]
});

router.beforeEach((to, from, next) => {
	const authRequired = to.matched.some(route => route.meta.auth);
	const token = localStorage.getItem("admin_user_token");

	if (!authRequired) {
		next();
		return; 
	}

	if (!token) {
		next("/login");
		return;
	}
	
	const privilege = to.meta.privilege;
	if (privilege) {
		if (!store.getters.checkUserPrivilege(privilege)) {
			store.commit("showSnackbar", {
				color: "error",
				timeout: 3000,
				message: "un-authorized"
			});
			next("/");
			return;
		}
	}
	next();
});

export default router;